let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("10wPR")).then(() => parcelRequire('2jem1'));